import { useSelector } from 'react-redux'

import { Loading } from './loading'
import { Prompt } from './prompt'
import { isLoadingSelector, isSuccessSelector } from './selectors'
import { Success } from './success'

export const Modal = () => {
  const isLoading = useSelector(isLoadingSelector)
  const isSuccess = useSelector(isSuccessSelector)

  if (isLoading) {
    return <Loading />
  }

  if (isSuccess) {
    return <Success />
  }

  return <Prompt />
}
